import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _parseInt from "@babel/runtime-corejs2/core-js/parse-int";
import _Symbol from "@babel/runtime-corejs2/core-js/symbol";
import _Symbol$iterator from "@babel/runtime-corejs2/core-js/symbol/iterator";

/**
 * 获取是否隐私模式
 * @returns object
 */
export var getPrivate = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var t;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            t = false;
            _context.prev = 1;
            _context.next = 4;
            return new tt().getFingerprint();

          case 4:
            t = _context.sent;
            _context.next = 9;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);

          case 9:
            return _context.abrupt("return", t);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 7]]);
  }));

  return function getPrivate() {
    return _ref.apply(this, arguments);
  };
}();

function a(t) {
  return t.reduce(function (t, e) {
    return t + (e ? 1 : 0);
  }, 0);
}

function X() {
  return q(this, void 0, void 0, function () {
    var t, e;
    return J(this, function (n) {
      switch (n.label) {
        case 0:
          return 'storage' in (t = navigator) && 'estimate' in t.storage ? [4, t.storage.estimate()] : [3, 2];

        case 1:
          return [2, !!(e = n.sent().quota) && e < (r = navigator.userAgent, o = !1, i = !1, r && null !== r && (o = r.indexOf('Mac OS') > 0 && r.indexOf('iPhone') > -1, i = r.indexOf('CrOS') > 0), o || i ? 3221225472 : 1073741824)];

        case 2:
          return [2, !1];
      }

      var r, o, i;
    });
  });
}

function Y() {
  var t = document.createElement('iframe');
  t.style.display = 'none';

  try {
    var e = new _Promise(function (e) {
      t.contentWindow ? t.contentWindow.applicationCache.addEventListener('error', function () {
        return e(!0);
      }) : e(!1);
    }),
        n = new _Promise(function (t) {
      return setTimeout(function () {
        return t(!1);
      }, 20);
    });
    return document.body.appendChild(t), _Promise.race([e, n]);
  } finally {
    t.remove();
  }
}

function Z() {
  try {
    if (!window.indexedDB) return !0;
  } catch (t) {
    return !0;
  }

  return !1;
}

var Q,
    tt = function () {
  function t() {}

  return t.prototype.getFingerprint = function () {
    return function () {
      return q(this, void 0, void 0, function () {
        var t, e, n;
        return J(this, function (r) {
          switch (r.label) {
            case 0:
              return r.trys.push([0, 15,, 16]), a(['userActivation' in navigator, 'mediaSession' in navigator, 0 === navigator.vendor.indexOf('Google'), 'BackgroundFetchManager' in window, 'BatteryManager' in window, 'webkitMediaStream' in window, 'webkitSpeechGrammar' in window]) >= 5 ? function () {
                var t = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
                if (!t) throw 'UserAgent is not Google Chrome';
                return _parseInt(t[2], 10);
              }() >= 76 ? [4, X()] : [3, 2] : [3, 5];

            case 1:
              return t = r.sent(), [3, 4];

            case 2:
              return [4, new _Promise(function (t) {
                window.webkitRequestFileSystem(0, 1, function () {
                  return t(!1);
                }, function () {
                  return t(!0);
                });
              })];

            case 3:
              ;
              t = r.sent(), r.label = 4;

            case 4:
              return [2, t];

            case 5:
              return /Apple/.test(navigator.vendor) && /Safari/.test(navigator.userAgent) ? function () {
                var t = navigator.userAgent.match(/Version\/([0-9._]+).*Safari/);
                if (!t) throw new Error('UserAgent is not Safari');
                var e = t[1].split('.').map(function (t) {
                  return isNaN(_parseInt(t)) ? 0 : _parseInt(t);
                });
                return {
                  major: e[0],
                  minor: e[1],
                  patch: e[2]
                };
              }().major < 13 ? (e = function () {
                try {
                  window.openDatabase(null, null, null, null);
                } catch (t) {
                  return !0;
                }

                try {
                  return window.localStorage.setItem('test', '1'), window.localStorage.removeItem('test'), !1;
                } catch (t) {
                  return !0;
                }
              }(), [3, 10]) : [3, 6] : [3, 11];

            case 6:
              return 'safari' in window ? (n = function () {
                try {
                  window.safari.pushNotification.requestPermission('https://example.com', 'private', {}, function () {});
                } catch (t) {
                  return !new RegExp([103, 101, 115, 116, 117, 114, 101].map(function (t) {
                    return String.fromCharCode(t);
                  }).join('')).test(t);
                }

                throw new Error('Unexpected lack of error');
              }(), [3, 9]) : [3, 7];

            case 7:
              return [4, Y()];

            case 8:
              ;
              n = r.sent(), r.label = 9;

            case 9:
              ;
              e = n, r.label = 10;

            case 10:
              return [2, e];

            case 11:
              return o = document.documentElement, a(['buildID' in navigator, (null == o ? void 0 : o.style) && 'MozAppearance' in document.documentElement.style, 'MediaRecorderErrorEvent' in window, 'mozInnerScreenX' in window, 'CSSMozDocumentRule' in window, 'CanvasCaptureMediaStream' in window]) >= 4 ? [4, new _Promise(function (t) {
                try {
                  var e = window.indexedDB.open('test');
                  e.onerror = function () {
                    return t(!0);
                  }, e.onsuccess = function () {
                    return t(!1);
                  };
                } catch (e) {
                  return t(!0);
                }
              })] : [3, 13];

            case 12:
              return [2, r.sent()];

            case 13:
              return a(['msWriteProfilerMark' in window, 'msLaunchUri' in navigator, 'msSaveBlob' in navigator]) >= 2 ? [2, Z()] : [2, !1];

            case 14:
              return [3, 16];

            case 15:
              return r.sent(), [2, !1];

            case 16:
              return [2];
          }

          var o;
        });
      });
    }();
  }, t;
}(),
    q = function q(t, e, n, r) {
  return new (n || (n = _Promise))(function (o, i) {
    function a(t) {
      try {
        u(r.next(t));
      } catch (t) {
        i(t);
      }
    }

    function c(t) {
      try {
        u(r.throw(t));
      } catch (t) {
        i(t);
      }
    }

    function u(t) {
      var e;
      t.done ? o(t.value) : (e = t.value, e instanceof n ? e : new n(function (t) {
        t(e);
      })).then(a, c);
    }

    u((r = r.apply(t, e || [])).next());
  });
},
    J = function J(t, e) {
  var n,
      r,
      o,
      i,
      a = {
    label: 0,
    sent: function sent() {
      if (1 & o[0]) throw o[1];
      return o[1];
    },
    trys: [],
    ops: []
  };
  return i = {
    next: c(0),
    throw: c(1),
    return: c(2)
  }, 'function' == typeof _Symbol && (i[_Symbol$iterator] = function () {
    return this;
  }), i;

  function c(i) {
    return function (c) {
      return function (i) {
        if (n) throw new TypeError('Generator is already executing.');

        for (; a;) {
          try {
            if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

            switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
              case 0:
              case 1:
                o = i;
                break;

              case 4:
                return a.label++, {
                  value: i[1],
                  done: !1
                };

              case 5:
                a.label++, r = i[1], i = [0];
                continue;

              case 7:
                ;
                i = a.ops.pop(), a.trys.pop();
                continue;

              default:
                if (!((o = (o = a.trys).length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                  a = 0;
                  continue;
                }

                if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                  a.label = i[1];
                  break;
                }

                if (6 === i[0] && a.label < o[1]) {
                  ;
                  a.label = o[1], o = i;
                  break;
                }

                if (o && a.label < o[2]) {
                  ;
                  a.label = o[2], a.ops.push(i);
                  break;
                }

                o[2] && a.ops.pop(), a.trys.pop();
                continue;
            }

            i = e.call(t, a);
          } catch (t) {
            ;
            i = [6, t], r = 0;
          } finally {
            n = o = 0;
          }
        }

        if (5 & i[0]) throw i[1];
        return {
          value: i[0] ? i[1] : void 0,
          done: !0
        };
      }([i, c]);
    };
  }
};